import { GET_WORKING_CAPITAL_STATEMENTS, GET_WORKING_CAPITAL_STATEMENT_DETAIL, WORKING_CAPITAL_REPAYMENT } from './flexProgramConstants';

const initialState = {
  statements: [],
  totalStatements: 0,
  currentPage: 1,
  totalPages: 1,
  pageSize: 1000,
  statementDetail: null,
  repaymentResult: null
};

export default function flexProgramReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case GET_WORKING_CAPITAL_STATEMENTS:
      return {
        ...state,
        statements: payload.statements || [],
        totalStatements: payload.totalStatements || 0,
        currentPage: payload.currentPage || 1,
        totalPages: payload.totalPages || 1,
        pageSize: payload.pageSize || 1000
      };
    case GET_WORKING_CAPITAL_STATEMENT_DETAIL:
      return {
        ...state,
        statementDetail: payload.statementDetail
      };
    case WORKING_CAPITAL_REPAYMENT:
      return {
        ...state,
        repaymentResult: {
          success: payload.success,
          message: payload.message
        }
      };
    default:
      return state;
  }
} 